import { STATIC_ASSET_BASE_URL } from '@/utility/constants';
import { t } from '@/utility/localization';

export const CHAT_TAB_ID = 'chat';
export const GENERAL_TAB_ID = 'public_page';
export const INTEGRATION_TAB_ID = 'integration';
export const MEMBER_ACCESS_TAB_ID = 'member_access';
export const EMAIL_PREFERENCES_TAB_ID = 'email_preferences';
export const ROLE_CONFIGURATION_TAB_ID = 'role_configuration';
export const FEES_TAB_ID = 'fees';
export const DISCOUNT_TAB_ID = 'discount';
export const PAYOUT_TAB_ID = 'payout';

export const getTabFilters = () => {
  const tabs = [
    {
      id: GENERAL_TAB_ID,
      label: t('public-page'),
      testId: 'c-SettingsMainContent-public-page-access'
    },
    {
      id: MEMBER_ACCESS_TAB_ID,
      label: t('member-access'),
      testId: 'c-SettingsMainContent-tab-member-access'
    },
    {
      id: CHAT_TAB_ID,
      label: t('chat'),
      testId: 'c-SettingsMainContent-tab-chat'
    }
  ];

  tabs.push({
    id: EMAIL_PREFERENCES_TAB_ID,
    label: t('email-preferences'),
    testId: 'c-SettingsMainContent-tab-email-preferences'
  });

  return tabs;
};
export const tabFilterWithNFT = {
  id: ROLE_CONFIGURATION_TAB_ID,
  label: 'Discord Verification',
  testId: 'c-SettingsMainContent-tab-discord-verification'
};

export const DISCOUNT_TAB_LANDING_IMAGE = `${STATIC_ASSET_BASE_URL}/nasIO/chatsAndSettings/DiscountLandingImage.png`;

export const DISCORD_VERIFICATION_TAB_CONFIGURED_ROLE_IMAGE = `${STATIC_ASSET_BASE_URL}/nasIO/chatsAndSettings/discord-image-configured-role.png`;

export const DISCORD_VERIFICATION_TAB_ROLE_VERIFICATION_CREATION_IMAGE = `${STATIC_ASSET_BASE_URL}/nasIO/chatsAndSettings/discord-create-role-image-2.png`;

export const DISCORD_VERIFICATION_TAB_ROLE_VERIFICATION_CREATION_IMAGE_2 = `${STATIC_ASSET_BASE_URL}/nasIO/chatsAndSettings/discord-roles-image.png`;

export const EMPTY_SCREEN_FOR_SETTINGS = `${STATIC_ASSET_BASE_URL}/nasIO/chatsAndSettings/image-settings-empty.png`;

export const EMPTY_SCREEN_FOR_CHATS = `${STATIC_ASSET_BASE_URL}/nasIO/chatsAndSettings/chats-integration-empty.png`;
export const EMPTY_SCREEN_GRAPHIC = {
  alt: 'Empty screen',
  mobileImgProps: {
    src: `${STATIC_ASSET_BASE_URL}/nasIO/common/png/payout_empty_screen.png`,
    width: 660,
    height: 220,
    layout: 'responsive'
  }
};

export const TYPE_OF_FEES = {
  NAS_IO_FEE: 'NAS_IO_FEE',
  PROCESSING_FEE: 'PROCESSING_FEE',
  WITHHOLDING_TAX: 'WITHHOLDING_TAX'
};

export const NAS_IO_FEE_EXAMPLES = {
  USD: 100,
  INR: 1000,
  COP: 100000,
  PEN: 100,
  GBP: 100,
  IDR: 10000,
  PHP: 1000,
  MXN: 1000,
  AUD: 100,
  MYR: 100,
  BRL: 100,
  HUF: 10000,
  ILS: 100,
  AED: 100,
  EUR: 100,
  SGD: 100,
  CLP: 10000,
  BOB: 100,
  CAD: 100
};
